import mockLabelsData from "../../data/mockData/labelsData";
import { types } from "./action";

const initialState = {
  seed: mockLabelsData,
  tableRowResults: [],
  created: [],
};

function upsertById(rows, row) {
  if (!row || row.id == null) {
    return rows;
  }
  const sid = String(row.id);
  const idx = rows.findIndex(r => String(r.id) === sid);
  if (idx >= 0) {
    const next = [...rows];
    next[idx] = { ...next[idx], ...row };
    return next;
  }
  return [...rows, row];
}

export default (state = initialState, action) => {
  switch (action.type) {
    case types.SET_LABELS:
      return {
        ...state,
        tableRowResults: Array.isArray(action.payload) ? action.payload : state.tableRowResults,
      };
    case types.ADD_LABEL: {
      const row = action.payload;
      if (!row || row.id == null) {
        return state;
      }
      const exists = state.created.some(r => String(r.id) === String(row.id));
      if (exists) {
        return state;
      }
      return {
        ...state,
        created: [...state.created, row],
      };
    }
    case types.UPDATE_LABEL: {
      const row = action.payload;
      if (!row || row.id == null) {
        return state;
      }
      return {
        ...state,
        created: upsertById(state.created, row),
      };
    }
    case types.DELETE_LABEL: {
      const id = action.payload;
      if (id == null) {
        return state;
      }
      const sid = String(id);
      return {
        ...state,
        created: state.created.filter(r => String(r.id) !== sid),
        tableRowResults: state.tableRowResults.filter(r => String(r.id) !== sid),
      };
    }
    default:
      return state;
  }
};
